export type EditorPluginName = (typeof editorPluginNames)[number];
export type ViewerPluginName = (typeof viewerPluginNames)[number];

export const viewerPluginNames = [
  'actionButton',
  'audio',
  'codeBlock',
  'collapsibleList',
  'divider',
  'file',
  'gallery',
  'giphy',
  'hashtag',
  'html',
  'image',
  'link',
  'linkButton',
  'linkPreview',
  'mentions',
  'poll',
  'spoiler',
  'table',
  'textColor',
  'textHighlight',
  'verticalEmbed',
  'video',
] as const;

export const editorPluginNames = [
  'ai',
  'layout',
  'emoji',
  'heading',
  'indent',
  'lineSpacing',
  ...viewerPluginNames,
] as const;

const nextPluginToLegacyMap: Record<EditorPluginName, string> = {
  ai: 'wix-rich-content-plugin-ai',
  emoji: 'wix-draft-plugin-emoji',
  heading: 'wix-rich-content-plugin-headings',
  indent: 'wix-rich-content-plugin-indent',
  lineSpacing: 'line-spacing',
  actionButton: 'wix-draft-plugin-action-button',
  audio: 'ricos-audio',
  codeBlock: 'code-block',
  collapsibleList: 'wix-rich-content-plugin-collapsible-list',
  divider: 'wix-draft-plugin-divider',
  file: 'wix-draft-plugin-file-upload',
  gallery: 'wix-draft-plugin-gallery',
  giphy: 'wix-draft-plugin-giphy',
  hashtag: 'wix-draft-plugin-hashtag',
  html: 'wix-draft-plugin-html',
  image: 'wix-draft-plugin-image',
  link: 'LINK',
  linkButton: 'wix-draft-plugin-link-button',
  linkPreview: 'wix-draft-plugin-link-preview',
  mentions: 'wix-draft-plugin-external-mentions',
  poll: 'wix-draft-plugin-poll',
  spoiler: 'wix-rich-content-plugin-spoiler',
  table: 'wix-rich-content-plugin-table',
  textColor: 'wix-rich-content-text-color',
  textHighlight: 'wix-rich-content-text-highlight',
  verticalEmbed: 'wix-draft-plugin-vertical-embed',
  video: 'wix-draft-plugin-video',
  layout: 'layout',
};

export const legacyPluginToNextMap: Record<string, EditorPluginName> = Object.fromEntries(
  Object.entries(nextPluginToLegacyMap).map(([key, value]) => [value, key])
) as any;
